import React, { useEffect, useState, useContext } from 'react';
import { Dialog, DialogTitle, DialogContent,
         Button, List, ListItem, ListItemText, IconButton, 
         Typography, Box, RadioGroup, 
         FormControlLabel, Radio, Divider, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import axios from 'axios';
import AddressDialog from './AddressDialog';
import PointOfSale from '@mui/icons-material/PointOfSale';
import { Mycontext } from "../../mycontext";

const apiUrl = process.env.REACT_APP_API_URL;

const ChartDialog = ({ open, onClose, data }) => {
  const [cartItems, setCartItems] = useState([]);
  const [deliveryOption, setDeliveryOption] = useState('pickup');
  const [address, setAddress] = useState({
    street: '',
    city: '',
    postalCode: '',
    phone: ''
  });
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [addressDialogOpen, setAddressDialogOpen] = useState(false);
  const [Errormesage, setErrorMesage] = useState('');

  const context = useContext(Mycontext);
  const { setCartItemsCount, cartItemsData, setCartItemsData } = context;

  useEffect(() => {
    if (open) {
      
      setCartItems(cartItemsData)
    }
    else{
      setErrorMesage('');
    }
  }, [open,data]);
  

  const handleRemoveItem = (item) => {
    const updatedItems = cartItems.filter(cartItem => cartItem !== item);
    setCartItems(updatedItems);
    setCartItemsData(updatedItems)
    window.localStorage.setItem('chart', JSON.stringify(updatedItems))
    setCartItemsCount(updatedItems.length)
    if(updatedItems.length ===0)
      window.localStorage.removeItem('klarna_order_id')
      onClose()
  };
 
  const prosentihinta =(sale)=>{
    if (sale.toString().indexOf('%') > -1){
      function laske (sal){
        let getsplit =sal.split('%')
        return parseInt( getsplit[0] * ((100-getsplit[1])/100) )
      }
      let cht= [...cartItems]
      cht.forEach((el,index) => { cht[index].sale =  laske(el.sale)})
      setCartItems(cht)
      return laske(sale)
    }
    else{
      return sale
    }
  }

  const handleCheckout = () => {
    
    let str_adrs= (deliveryOption === 'home')? address.street + ' ,'+ address.postalCode+' '+ address.city:'' 
    axios.post(apiUrl + '/api/create-order', { cartItems, deliveryFee, address, deliveryOption,str_adrs })
      .then(response => {
        const data = response.data;
        
        if (data.klarna_order_id) {
          setErrorMesage('')
          console.log(data.klarna_order_id)
          window.localStorage.setItem ('klarna_order_id',data.klarna_order_id);
          window.location.href = `/checkout`;
        }
      })
      .catch(error =>{ console.error('Error:', error);
           setErrorMesage('Tapahtui virhe. Yritä myöhemmin uudelleen')});
  };

  const handleAddressSubmit = (newAddress,delivery) => {
    setAddress(newAddress);
    setAddressDialogOpen(false);
    setDeliveryFee(delivery)
  };
  
  const handleAddressClose = () => {
    setDeliveryOption('pickup');
    setAddressDialogOpen(false);
    
  };
  const calculateTotal = () => {
    const itemsTotal = cartItems.reduce((total, item) => total + parseFloat(prosentihinta(item.sale)), 0);
    return (itemsTotal + (deliveryOption === 'home' ? deliveryFee : 0)).toFixed(2);
  };

  const hasItems = cartItems.length > 0;

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          style: {
            position: 'fixed',
            right: 0,
            top: '2vh',
            margin: 0,
            width: {xs:'90%', md:'50%', lg:'30%'},
            height: '90%',
          },
        }}
      >
        <DialogTitle >
         <Typography sx={{ fontFamily: "'Baloo Bhaijaan', cursive"}} mt='2vh' variant='h4'>Ostoskorisi</Typography> </DialogTitle>
         <Divider width='90%' variant="middle"></Divider>
         <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              height: '100%',
            }}
          >
              <Box>
                <List>
                  {cartItems.map(item => (
                    <ListItem key={item.id} style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={apiUrl + '/images/' + item.imgs.split(',')[0]}
                        alt={item.name}
                        style={{ maxHeight:'75px',width: '25%', marginRight: '2%', objectFit: 'cover' }}
                      />
                      <ListItemText primary={item.name} secondary={`Määrä: 2 | Hinta: ${prosentihinta(item.sale)} €`} />
                      <IconButton edge="end" onClick={() => handleRemoveItem(item)}>
                        <CloseIcon />
                      </IconButton>
                    </ListItem>
                  ))}
                </List>
              </Box>
              <Box mt={2}>
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group">Toimitusvaihtoehdot</FormLabel>
                  <RadioGroup value={deliveryOption} onChange={(e) => setDeliveryOption(e.target.value)}>
                    <FormControlLabel
                      value="pickup"
                      control={<Radio color="success" />}
                      label="Nouda (ilmainen)"
                    />
                    <FormControlLabel
                      value="home"
                      control={<Radio color="success" />}
                      label="Toimitus"
                      onClick={() => setAddressDialogOpen(true)}
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
              {deliveryOption === 'home' && address.street ? (
                <Box mt="2vh" mb={2}>
                  <Typography variant="subtitle1">
                    Adres: {address.street}, {address.city}, {address.postalCode}, Telefon: {address.phone}
                  </Typography>
                  <Typography variant="subtitle1">Toimitus: {deliveryFee} €</Typography>
                </Box>
              ) : (
                <Box mt="2vh" mb={2}>
                  <Typography variant="subtitle1">Nouto Niittyläntie 3 00620 Helsinki aukioloaikoina</Typography>
                </Box>
              )}
              <Box mt="2vh" mb={2}>
                <Typography variant="subtitle1">
                  Tuotteet: {cartItems.reduce((total, item) => total + parseFloat(prosentihinta(item.sale)), 0)} €
                </Typography>
                <Typography variant="subtitle1">
                  Toimitus: {(deliveryOption === 'home' ? deliveryFee : 0).toFixed(2)} €
                </Typography>
                <Typography variant="h6">Välisumma: {calculateTotal()} €</Typography>
              </Box>
            <Box width="100%" display="flex" justifyContent="center" >
              <Button
                onClick={handleCheckout}
                variant="contained"
                disabled={!hasItems}
                sx={{  width:'70%', fontFamily: "'Baloo Bhaijaan', cursive",  fontWeight: 400, fontSize:18}}
                color='error'
                startIcon={<PointOfSale></PointOfSale>}
              >
                KASSA
              </Button>
            
            </Box>
            <Box width="100%" display="flex" justifyContent='left' >
              <Typography component='a' href='/ostoehdot' variant="h6" color='textPrimary'>Ostaehdot</Typography>
            </Box>
            <Box width="100%" display="flex" justifyContent="center" >
              <Typography display={Errormesage === '' ?'none':'block'} variant="h6" color='red'>{Errormesage}</Typography>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <AddressDialog 
        open={addressDialogOpen} 
        onClose={handleAddressClose} 
        onSubmit={handleAddressSubmit}
      />
    </>
  );
};

export default ChartDialog;